<template>
  <div>
    <MapModal
      :modalNode="modalNode"
      :close="cancel"
      :title="routeInteractionTitle"
      id="routeInteraction"
    >
      <template slot="content">
        <schemeDesignLine
          ref="schemeDesignLine"
          @getPlanGuid="getPlanGuid($event)"
          @getDesignLineGuid="getDesignLineGuid($event)"
        ></schemeDesignLine>
      </template>
      <template slot="foot">
        <div class="foot-operate">
          <el-button type="primary" @click="cancel">
            取消
          </el-button>
          <el-button type="primary" @click="lineInfo">
            线元详情
          </el-button>
          <el-button type="primary" @click="onSubmit">
            绘制
          </el-button>
        </div>
      </template>
    </MapModal>
    <lineAbout
      v-if="isLineAbout"
      :tableData="tableData"
      :close="() => (isLineAbout = false)"
    ></lineAbout>
  </div>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");
const schemeDesignLine = () => import("./schemeDesignLine.vue");
const lineAbout = () => import("./lineAbout.vue");

import { getPointsBySpacingService, getElementsService } from "@/api/api";
import * as mapWork from "./map.js";

export default {
  name: "routeInteraction",
  components: { MapModal, schemeDesignLine, lineAbout },
  props: ["close"],
  data() {
    return {
      routeInteractionTitle: "线元信息",
      modalNode: {
        trafficSimulationAdd: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 106,
            y: -376,
          },
          height: "auto", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      projectId: window.sessionStorage.getItem("nowProjectId"),
      planGuid: null,
      designLineGuid: null,
      tableData: [],
      isLineAbout: false,
    };
  },
  methods: {
    cancel() {
      mapWork.clearLayer();
      this.close();
    },
    getPlanGuid(data) {
      this.planGuid = data;
      this.isLineAbout = false;
    },
    getDesignLineGuid(data) {
      this.designLineGuid = data;
      this.isLineAbout = false;
    },
    lineInfo() {
      if (!this.$refs.schemeDesignLine.requiredCheck("form")) return;
      getElementsService({
        planGuid: this.planGuid,
        designLineGuid: this.designLineGuid,
      }).then((res) => {
        this.tableData = res.data.data;
        this.$nextTick(() => {
          this.isLineAbout = true;
        });
      });
    },
    // 确定
    onSubmit() {
      if (!this.$refs.schemeDesignLine.requiredCheck("form")) return;
      mapWork.createLayer();
      mapWork.graphicDotsine.clear();
      getPointsBySpacingService({
        planGuid: this.planGuid,
        designLineGuid: this.designLineGuid,
      }).then((res) => {
        console.log(res.data.data);
        // let arr = [];
        // res.data.data.forEach((item) => {
        //   arr.push(
        //     mars3d.PointTrans.proj4Trans(
        //       [item[0], item[1], item[2]],
        //       "+proj=tmerc +lat_0=0 +lon_0=107.666666667 +k=1 +x_0=500000 +y_0=0 +a=6379040 +rf=298.257 +units=m +no_defs",
        //       mars3d.CRS.EPSG4326
        //     )
        //   );
        // });
        // mapWork.createLineEl(arr);
        mapWork.createLineEl(res.data.data);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
@import "@/assets/scss/box.scss";
.foot-operate {
  padding: 10px 10px;
  border-top: 1px solid rgba(245, 245, 245, 0.6) !important;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  /deep/ .el-button {
    margin: 0 5px;
    font-size: 12px;
    padding: 3px 10px;
    line-height: inherit;
    height: auto;
  }
}
.positioning {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -20px;
  padding-bottom: 20px;
  margin-bottom: 20px;
  font-size: 12px;
  color: #fff;
  span {
    padding-right: 0px;
    padding-left: 7px;
  }
  /deep/ .el-button {
    margin-right: 100px;
    margin-left: 11px;
    font-size: 12px;
    padding: 3px 10px;
    line-height: inherit;
    height: auto;
    border-color: rgba(42, 183, 255, 0.66) !important;
    background-color: rgba(42, 183, 255, 0.66) !important;
  }
}

/deep/ .el-table,
/deep/ .el-table__expanded-cell {
  background-color: transparent;
}
/* 表格内背景颜色 */
/deep/ .el-table th,
/deep/ .el-table tr,
/deep/ .el-table td {
  background-color: transparent;
  border: none;
  color: #fff;
  font-size: 13px;
}
/deep/.el-table th.el-table__cell > .cell {
  color: #ffffff;
}
/deep/.el-table td.el-table__cell,
/deep/.el-table th.el-table__cell.is-leaf {
  border: none;
}
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background: none;
}
/deep/ .el-table tbody tr:hover > td {
  background-color: transparent !important;
}
</style>
